export const BASE_MEDIUM_FONT_IN_PX = 16;

export const SCALE_ERROR_DELTA = 0.05;
